import {Component, EventEmitter, OnInit, Output, inject} from '@angular/core';
import {AppInfoService} from '../../../../core/services/app-info.service';
import {VtnGenericaComponent} from '../vtn-generica/vtn-generica.component';
import {ClsConfig} from '../../../../util/cls-config';
import {TranslateModule} from '@ngx-translate/core';
import {IgxLayoutDirective} from '@infragistics/igniteui-angular/directives';
import {IgxIconComponent} from '@infragistics/igniteui-angular/icon';
import {IGX_CARD_DIRECTIVES, IgxCardModule} from '@infragistics/igniteui-angular/card';
import {IgxCheckboxComponent, IgxCheckboxModule} from '@infragistics/igniteui-angular/checkbox';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent, IgxInputDirective} from '@infragistics/igniteui-angular/input-group';
import {FormsModule} from '@angular/forms';
import {IgxPdfExporterOptions} from '@infragistics/igniteui-angular/grids/core';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {
  IGX_SELECT_DIRECTIVES,
  IgxSelectComponent,
  IgxSelectItemComponent,
  IgxSelectModule
} from '@infragistics/igniteui-angular/select';
import {INeodataBtnsFooter} from '../../../../core/models/interfaces/generico-interface';
import {EnumPosicionBtn} from '../../../../core/models/enum/enum-mas-opciones';

export interface ClsOpcionesPDF {
  ignoreColumnsVisibility: boolean;
  freezeHeaders: boolean;
  exportSummaries: boolean;
  pageOrientation: 'portrait' | 'landscape';
  pageSize?: string;
  showTableBorders: boolean;
  fontSize: number;
}

@Component({
  selector: 'app-personalizar-pdf',
  templateUrl: './personalizar-pdf.component.html',
  styleUrls: ['./personalizar-pdf.component.scss'],
  imports: [
    TranslateModule,
    IgxLayoutDirective,
    IgxCardModule,
    IGX_CARD_DIRECTIVES,
    FormsModule,
    IGX_SELECT_DIRECTIVES,
    IgxCheckboxComponent,
    IgxCheckboxModule,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxInputGroupComponent,
    IgxInputDirective,
    IgxIconComponent,
    IgxSelectComponent,
    IgxSelectItemComponent
  ]
})
export class PersonalizarPdfComponent extends ClsConfig implements OnInit {
  public infApp = inject(AppInfoService);
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();

  public vtnGenerico: VtnGenericaComponent;

  @Output()
  public opcionesConfirmadas: EventEmitter<ClsOpcionesPDF> = new EventEmitter<ClsOpcionesPDF>();

  public opciones: ClsOpcionesPDF = {
    ignoreColumnsVisibility: false,
    freezeHeaders: true,
    exportSummaries: true,
    pageOrientation: 'portrait',
    pageSize: 'A4',
    showTableBorders: true,
    fontSize: 10
  };

  public pageSizes: string[] = ['A4', 'Letter', 'Legal', 'A3', 'A5', 'Tabloid', 'Ledger', 'A0', 'A1', 'A2', 'A6', 'B4', 'B5', 'B0'];

  ngOnInit(): void {
    this.vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
      switch (btn.id.toUpperCase()) {
        case 'ACEPTAR':
          this.confirmar();
          break;
        default:
          this.cancelar();
      }
    });
  }

  public open() {
    this.opciones = {
      ignoreColumnsVisibility: false,
      freezeHeaders: true,
      exportSummaries: true,
      pageOrientation: 'portrait',
      pageSize: 'A4',
      showTableBorders: true,
      fontSize: 10
    };
    this.vtnGenerico.btnsAccion = [
      {
        id: 'ACEPTAR',
        texto: 'BOTONES.ACEPTAR',
        titulo: 'BOTONES.ACEPTAR',
        icono: '',
        tipoBoton: 'contained',
        posicion: EnumPosicionBtn.DERECHO
      },
      {
        id: 'CANCELAR',
        texto: 'BOTONES.CANCELAR',
        titulo: 'BOTONES.CANCELAR',
        icono: '',
        tipoBoton: 'flat',
        posicion: EnumPosicionBtn.DERECHO
      }
    ];
    this.vtnGenerico.open(250, 540, 'MENSAJES.PDF.PERSONALIZAR_PDF', 'settings');
  }

  public close() {
    this.vtnGenerico.close();
  }

  public confirmar() {
    this.opcionesConfirmadas.emit({...this.opciones});
    this.close();
  }

  public cancelar() {
    this.close();
  }

  public aplicarOpcionesAExporter(exporterOptions: IgxPdfExporterOptions, opciones: ClsOpcionesPDF): void {
    exporterOptions.ignoreColumnsVisibility = opciones.ignoreColumnsVisibility;
    exporterOptions.freezeHeaders = opciones.freezeHeaders;
    exporterOptions.exportSummaries = opciones.exportSummaries;

    // orientación de página
    if (opciones.pageOrientation) {
      exporterOptions.pageOrientation = opciones.pageOrientation;
    }

    // tamaño de página
    if (opciones.pageSize) {
      exporterOptions.pageSize = opciones.pageSize as any;
    }

    // mostrar bordes de tabla
    if (opciones.showTableBorders !== undefined) {
      exporterOptions.showTableBorders = opciones.showTableBorders;
    }

    // tamaño de fuente
    if (opciones.fontSize !== undefined) {
      exporterOptions.fontSize = opciones.fontSize;
    }
  }
}

